import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { financecommerceApi, type FinanceDashboard } from '../../api/financecommerce';

const NAV = [
  { to: '/finance/settlements', label: 'Settlements' },
  { to: '/finance/reconciliation', label: 'Reconciliation' },
  { to: '/finance/accounting', label: 'Accounting' },
  { to: '/finance/gst', label: 'GST' },
  { to: '/finance/tally', label: 'Tally sync' },
  { to: '/finance/analytics', label: 'Analytics' },
];

export function FinanceHubPage() {
  const [dashboard, setDashboard] = useState<FinanceDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void financecommerceApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Settlements', value: dashboard.total_settlements },
        { label: 'Net settlement', value: `₹${dashboard.net_settlement.toFixed(0)}` },
        { label: 'Total fees', value: `₹${dashboard.total_fees.toFixed(0)}` },
        { label: 'Pending recon', value: dashboard.pending_recon },
        { label: 'Posted journals', value: dashboard.posted_journals },
        { label: 'Financial health', value: `${(dashboard.financial_health * 100).toFixed(0)}%` },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Financial Commerce</h1>
      <p className="mt-1 text-sm text-slate-600">Settlements, reconciliation, accounting, GST and Tally integration.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
